export default "__VITE_ASSET__Tfd4w2BH__"